import { render, staticRenderFns } from "./success.vue?vue&type=template&id=a201b6de&scoped=true"
import script from "./success.vue?vue&type=script&lang=js"
export * from "./success.vue?vue&type=script&lang=js"
import style0 from "./success.vue?vue&type=style&index=0&id=a201b6de&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a201b6de",
  null
  
)

export default component.exports